import plotDetail from '@/router/modules/productManage/plotDetail'
import cropBreedHistory from '@/router/modules/productManage/cropBreedHistory'

export default {
  path: '/product-manage',
  name: 'ProductManage',
  meta: {
    title: '生产管理',
    showTabBar: true
  },
  redirect: {
    name: 'MyPlot'
  },
  component: () => import('@/views/layout/Container'),
  children: [
    {
      path: 'my-plot',
      name: 'MyPlot',
      meta: {
        title: '我的地块',
        showTabBar: true
      },
      component: () => import('@/views/productManage/MyPlot')
    },
    {
      path: 'map-mode',
      name: 'MapMode',
      meta: {
        title: '地图模式',
        showTabBar: false
      },
      component: () => import('@/views/productManage/MapMode')
    },
    {
      path: 'trance-source',
      name: 'TraceSource',
      meta: {
        title: '溯源',
        showTabBar: false
      },
      props: route => ({
        traceCode: route.query.traceCode
      }),
      component: () => import('@/views/productManage/TraceSource')
    },
    {
      path: 'trance-source-editor',
      name: 'TraceSourceEditor',
      meta: {
        title: '溯源编辑器',
        showTabBar: false
      },
      props: route => ({
        traceCode: route.query.traceCode,
        formType: route.query.formType
      }),
      component: () => import('@/views/productManage/TraceSource/TraceSourceEditor')
    },
    plotDetail,
    cropBreedHistory
  ]
}

